/**
 * API Reference documentation page — v2 endpoint details.
 */

import { createFileRoute } from "@tanstack/react-router";
import { DocsPage } from "@/components/docs/docs-page";
import { apiReferenceContent } from "@/constants/docs/api-reference";

export const Route = createFileRoute("/docs/api-reference")({
	component: ApiReferencePage,
});

function ApiReferencePage() {
	return <DocsPage title="Endpoints" content={apiReferenceContent} />;
}
